import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { addOnlinePayForOther } from 'services/easyPay'

export default function useGetFuckHamyan() {
    const navigate = useNavigate()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddOnlinePayForOtherPayload) => {
            return addOnlinePayForOther(payload)
        },
        onSuccess: (result, variables) => {
            navigate('/funds')
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
            navigate('/funds')
        },
    })
    return { mutate }
}
